import Vue from 'vue';
import VeeValidate, { Validator } from 'vee-validate';
import de from 'vee-validate/dist/locale/de';

de.messages.max_value = (field, [max]) => `${field} muss ${max} oder weniger sein.`;
de.messages.min_value = (field, [max]) => `${field} muss ${max} oder mehr sein.`;

Validator.localize('de', de);

Vue.use(VeeValidate, {
  fieldsBagName: 'inputs ', // Default is fields
});



// WEBPACK FOOTER //
// ./src/plugins/vee-validate.js